<template>
  <div>
    <v-data-table
      :calculate-widths="true"
      dense
      :items="items"
      :footer-props="{
        'items-per-page-options': [10, 25, 50, 100],
      }"
      :items-per-page="25"
      :headers="headers"
      hide-default-header
      class="elevation-1"
      style="font-size:10px"
      :loading="loading"
      loading-text="Cargando... Por favor espere"
      :mobile-breakpoint="100"
      @update:pagination="updatePagination"
    >
      <template v-slot:item.descripcion="{ item }">
        <div>
          <v-toolbar flat color="transparent">
            <v-toolbar-title class="text-body-1" :key="componentKey">
              <v-btn
                color="primary"
                v-if="item.tipo_necesidad == 'Ínfimas Cuantías'"
                class="mr-2"
                sm
                outlined
                small
              >
                {{ item.tipo_necesidad }}
              </v-btn>
              <v-btn color="success" v-else class="ma-2" sm outlined small>
                {{ item.tipo_necesidad }}
              </v-btn>
              <span
                v-if="item.highlight && item.highlight.codigo_proceso"
                v-html="item.highlight.codigo_proceso.join('')"
              ></span>
              <span v-else>
                {{ item.codigo_proceso }}
              </span>

              <v-btn
                text
                icon
                x-small
                @click="copyToClipboard(item.codigo_proceso, item.url)"
              >
                <v-icon>mdi-link-variant</v-icon>
              </v-btn>

              <v-chip
                v-if="checkMark(item.codigo_proceso) == 'revisado'"
                class="ma-2"
                color="cyan"
                pill
                text-color="white"
                small
                transition="scale-transition"
              >
                <v-icon left>
                  mdi-check
                </v-icon>
                Revisado
              </v-chip>
              <v-chip
                v-else-if="checkMark(item.codigo_proceso) == 'favorito'"
                class="ma-2"
                color="yellow darken-3"
                pill
                text-color="white"
                small
                transition="scale-transition"
              >
                <v-icon left>
                  mdi-star
                </v-icon>
                Favorito
              </v-chip>
              <v-chip
                v-else
                class="ma-2"
                outlined
                color="grey lighten-2"
                pill
                text-color="grey"
                small
                transition="scale-transition"
              >
                Sin etiqueta
              </v-chip>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <!-- <v-btn icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn> -->
          </v-toolbar>
          <!--  <v-chip small outlined class="mr-1">
            INFIMA CUANTÍA
          </v-chip> -->
          <!-- <v-chip small outlined> {{ item.pac_tipo | uppercase }} </v-chip >-->

          <v-row no-gutters>
            <v-col>
              <strong>Entidad Contratante: </strong>

              <span
                v-if="item.highlight && item.highlight.nombre_entidad"
                v-html="item.highlight.nombre_entidad.join('')"
              ></span>
              <span v-else>
                {{ item.nombre_entidad }}
              </span>
              <br />
              <br />

              <strong>Provincia / Cantón: </strong>
              <v-chip small outlined>
                <v-icon small left>mdi-map-marker</v-icon>
                {{ item.provincia_entidad }} / {{ item.canton_entidad }}
              </v-chip>
              <br />
              <br />
              <strong>Descripción de la compra: </strong>
              <span
                v-if="item.highlight && item.highlight.objeto_proceso"
                v-html="item.highlight.objeto_proceso.join('')"
              ></span>
              <span v-else>
                {{ item.objeto_proceso }}
              </span>
              <br />

              <!--  <strong>Tipo: </strong>
              <v-btn
                color="primary"
                v-if="item.tipo_necesidad == 'Ínfimas Cuantías'"
                class="ma-2"
                sm
                outlined
                x-small
              >
                <v-icon left x-small>
                  mdi-circle
                </v-icon>
                {{ item.tipo_necesidad }}
              </v-btn>
              <v-btn color="success" v-else class="ma-2" sm outlined x-small>
                <v-icon left x-small>
                  mdi-circle
                </v-icon>
                {{ item.tipo_necesidad }}
              </v-btn> -->
            </v-col>
            <v-col>
              <!--               {{ $moment() }}
              {{ $moment().startOf('day') }}
              {{ $moment().diff($moment(item.fecha_limite_propuesta).add(5, 'hours').startOf('day'), "days") }} -->
              {{ item.fecha_publicacion }}
              <v-timeline align-top dense>
                <v-timeline-item color="grey lighten-1" small class="pt-0">
                  <v-row class="pa-0">
                    <v-col>
                      <strong>Fecha de publicación</strong>
                      <div>
                        {{
                          item.fecha_publicacion
                            | moment("add", "5 hours", "YYYY-MM-DD HH:mm:ss")
                        }}
                      </div>
                    </v-col>
                  </v-row>
                </v-timeline-item>

                <v-timeline-item
                  v-if="
                    $moment()
                      .startOf('day')
                      .diff(
                        $moment(item.fecha_limite_propuesta)
                          .add(5, 'hours')
                          .startOf('day'),
                        'days'
                      ) == 0
                  "
                  color="red"
                  small
                  class="pb-2"
                >
                  <v-row class="pa-0">
                    <v-col>
                      <strong>Fecha Límite entrega de Proformas</strong>
                      <div>
                        {{
                          item.fecha_limite_propuesta
                            | moment("add", "5 hours", "YYYY-MM-DD HH:mm:ss")
                        }}
                        ({{
                          item.fecha_limite_propuesta
                            | moment("add", "5 hours", "calendar")
                        }})
                      </div>
                    </v-col>
                  </v-row>
                </v-timeline-item>
                <v-timeline-item
                  v-else-if="
                    $moment()
                      .startOf('day')
                      .diff(
                        $moment(item.fecha_limite_propuesta)
                          .add(5, 'hours')
                          .startOf('day'),
                        'days'
                      ) == -1
                  "
                  color="orange lighten-1"
                  small
                  class="pb-2"
                >
                  <v-row class="pa-0">
                    <v-col>
                      <strong>Fecha Límite entrega de Proformas</strong>
                      <div>
                        {{
                          item.fecha_limite_propuesta
                            | moment("add", "5 hours", "YYYY-MM-DD HH:mm:ss")
                        }}
                        ({{
                          item.fecha_limite_propuesta
                            | moment("add", "5 hours", "calendar")
                        }})
                      </div>
                    </v-col>
                  </v-row>
                </v-timeline-item>
                <v-timeline-item
                  v-else
                  color="grey lighten-1"
                  small
                  class="pb-2"
                >
                  <v-row class="pa-0">
                    <v-col>
                      <strong>Fecha Límite entrega de Proformas</strong>
                      <div>
                        {{
                          item.fecha_limite_propuesta
                            | moment("add", "5 hours", "YYYY-MM-DD HH:mm:ss")
                        }}
                        ({{
                          item.fecha_limite_propuesta
                            | moment("add", "5 hours", "calendar")
                        }})
                      </div>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>

              <!--  <strong>Código de la necesidad: </strong>

              <span
                v-if="item.highlight && item.highlight.codigo_proceso"
                v-html="item.highlight.codigo_proceso.join('')"
              ></span>
              <span v-else>
                {{ item.codigo_proceso }}
              </span>
              <v-btn
                text
                icon
                x-small
                @click="copyToClipboard(item.codigo_proceso, item.url)"
              >
                <v-icon>mdi-link-variant</v-icon>
              </v-btn> -->
            </v-col>
          </v-row>

          <!--           <v-row no-gutters class="pt-2">
            <v-col>
              <strong>Fecha publicación: </strong>

              <span>{{
                item.fecha_publicacion
                  | moment("add", "5 hours", "YYYY-MM-DD HH:mm:ss")
              }}</span>
            </v-col>
            <v-col>
              <strong>Fecha Límite entrega de Proformas: </strong>

              <span
                >{{
                  item.fecha_limite_propuesta
                    | moment("add", "5 hours", "YYYY-MM-DD HH:mm:ss")
                }}
                ({{
                  item.fecha_limite_propuesta
                    | moment("add", "5 hours", "calendar")
                }})</span
              >
            </v-col>
          </v-row> -->

          <!--   <v-row no-gutters class="pt-3">
            <v-col>
              <strong>Entidad Contratante: </strong>

              <span
                v-if="item.highlight && item.highlight.nombre_entidad"
                v-html="item.highlight.nombre_entidad.join('')"
              ></span>
              <span v-else>
                {{ item.nombre_entidad }}
              </span>
            </v-col>
            <v-col>
              <strong>Funcionario Encargado: </strong>
              <br />
              <span>
                {{ item.funcionario_encargado }}
              </span>
              <br />
              <span>
                {{ item.email_encargado }}
              </span>
              <br />
              <strong>Dirección de entrega: </strong>
              {{ item.direccion_entrega }}
              <br /> 
              <strong>Provincia / Cantón: </strong>
              <v-chip small outlined>
                <v-icon small left>mdi-map-marker</v-icon>
                {{ item.provincia_entidad }} / {{ item.canton_entidad }}
              </v-chip></v-col
            >
          </v-row> -->

          <br />

          <strong>DETALLE DEL OBJETO DE LA COMPRA: </strong>
          <!--   <span
            v-if="item.highlight && item.highlight.objeto_proceso"
            v-html="item.highlight.objeto_proceso.join('')"
          ></span>
          <span v-else>
            {{ item.objeto_proceso }}
          </span> -->
          <br />
          <br />

          <v-simple-table dense style="background: transparent">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="width:90px">
                    No.
                  </th>
                  <th class="text-left" style="width:350px">
                    CPC NIVEL 9.
                  </th>
                  <th class="text-left">
                    DESCRIPCIÓN DEL ITEM
                  </th>
                  <th class="text-right" style="width:50px">
                    CANT.
                  </th>
                  <th class="text-right" style="width:50px">
                    UNIDAD
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in item.items" :key="item.item_no">
                  <td>{{ item.item_no }} de {{ item.total_items }}</td>
                  <td>
                    <span
                      v-if="
                        item.highlight && item.highlight.descripcion_cpc_full
                      "
                      v-html="item.highlight.descripcion_cpc_full.join('')"
                    ></span>
                    <span v-else>
                      {{ item.descripcion_cpc_full }}
                    </span>
                  </td>
                  <td style="width:auto">
                    <span
                      v-if="item.highlight && item.highlight.descripcion"
                      v-html="item.highlight.descripcion.join('')"
                    ></span>
                    <span v-else>
                      {{ item.descripcion }}
                    </span>
                  </td>
                  <td class="text-right">
                    {{ item.pac_cantidad | currency("") }}
                  </td>
                  <td>{{ item.pac_medida }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-alert
            class="mt-3"
            v-if="item.items.length < item.total_items"
            outlined
            icon="mdi-alert-outline"
            prominent
            border="left"
            type="warning"
          >
            <v-row align="center">
              <v-col class="grow">
                <strong>ADVERTENCIA:</strong>

                Este proceso tiene otros items que no se pueden visualizar ya
                que están registrados en otros Cpc´s
                <br />
                <!--   <strong
                  >Las referencias a sus procesos etiquetados solo se almacenan
                  de forma local y no se sincronizan con otros equipos o
                  usuarios.</strong
                > -->
              </v-col>
              <v-col class="shrink">
                <v-btn
                  color="warning"
                  v-if="item.total_items > 1"
                  class="ma-2"
                  sm
                  outlined
                  small
                  v-on:click="addFilter('codigo_proceso', item.codigo_proceso)"
                >
                  VER TODOS LOS ITEMS DE ESTE PROCESO
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
          <!--     <strong>DESCRIPCION DEL ITEM: </strong> [
          <strong>{{ item.item_no }} </strong>
          de
          <strong>{{ item.total_items }} </strong> ]
          <span
            v-if="item.highlight && item.highlight.descripcion"
            v-html="item.highlight.descripcion.join('')"
          ></span>
          <span v-else>
            {{ item.descripcion }}
          </span> -->

          <div class="d-flex justify-end pt-3">
            <div style="width: 210px">
              <seleccionar-marcador
                :proceso="item"
                @markAsChanged="handleMarkAsChanged"
              ></seleccionar-marcador>
            </div>
            <!--   <excell
              :items="item.items"
              :headers="xlsxHeaders"
              :fieldValues="xlsxFields"
              outlined="true"
            ></excell>
            <v-btn outlined color="secondary" @click="loadData()">
              <v-icon dark>mdi-timer-star-outline</v-icon>
              Enviar a Mis Favoritos
            </v-btn> -->
          </div>

          <br />
          <!--  <strong>CPC NIVEL 5: </strong>
          <span
            v-if="item.highlight && item.highlight.descripcion_cpc"
            v-html="item.highlight.descripcion_cpc.join('')"
          ></span>
          <span v-else>
            {{ item.descripcion_cpc }}
          </span>

          <br />
          <br />
          <strong>CPC NIVEL 9: </strong>
          <span
            v-if="item.highlight && item.highlight.descripcion_cpc_full"
            v-html="item.highlight.descripcion_cpc_full.join('')"
          ></span>
          <span v-else>
            {{ item.descripcion_cpc_full }}
          </span> -->
        </div>
      </template>
    </v-data-table>
    <v-snackbar v-model="snackbar" :vertical="true" color="secondary">
      <div v-html="snackbarText"></div>
      <v-btn outlined color="blue accent-2" @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { Cache } from "aws-amplify";
import { getFilterByValue } from "@/assets/columns";
import { mapGetters, mapActions } from "vuex";
import SeleccionarMarcador from "@/components/SeleccionarMarcador";

export default {
  name: "infimas-table-group",
  components: {
    SeleccionarMarcador,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: Boolean,
  },
  event: "fastFilterAdded",
  data() {
    return {
      componentKey: 0,
      snackbar: false,
      snackbarText: "",
      headers: [
        {
          text: "OBJETO DE LA CONTRATACIÓN / DESCRIPCIÓN DEL ITEM",
          value: "descripcion",
        },
      ],
      xlsxHeaders: [
        "AÑO",
        "CODIGO PROCESO",
        "FECHA PUBLICACIÓN",
        "FECHA LÍMITE ENTREGA PROFORMAS",
        "CONTRATANTE",
        "DESCRIPCIÓN",
        "CPC NIVEL 5",
        "CPC NIVEL 9",
        "PROVINCIA",
        "CANTON",
        "CANTIDAD",
        "MEDIDA",
        "URL",
      ],
      xlsxFields: [
        "ano",
        "codigo_proceso",
        "fecha_publicacion",
        "fecha_limite_propuesta",
        "nombre_entidad",
        "descripcion",
        "descripcion_cpc",
        "descripcion_cpc_full",
        "provincia_entidad",
        "canton_entidad",
        "pac_cantidad",
        "pac_medida",
        "url",
      ],
    };
  },
  computed: {
    ...mapGetters(["filters"]),
  },
  methods: {
    ...mapActions(["addFilterAction", "addSnapshotAction"]),
    handleMarkAsChanged(event) {
      console.log(event);
      this.componentKey += 1;
    },
    addFilter(value, param) {
      this.$emit("fastFilterAdded");

      let filter = {};
      filter.field = getFilterByValue(value);
      filter.param = param;
      //filter.component = "select";
      this.addFilterAction(filter);
      this.snackbarText = `Se agregó un filtro <strong>${filter.field.label.toUpperCase()}</strong>.`;
      this.snackbar = true;
      //console.log(filter);
    },
    updatePagination: function(pagination) {
      console.log("update:pagination", pagination);
    },
    checkMark: function(codigo_proceso) {
      return Cache.getItem(codigo_proceso);
    },
    copyToClipboard: function(codigo_proceso, url) {
      let that = this;
      this.$copyText(url).then(
        function() {
          that.snackbarText = `La url del proceso <strong>${codigo_proceso}</strong> se ha copiado al portapapeles.`;
          that.snackbar = true;
        },
        function() {
          that.snackbarText = `Error al intentar copiar la url del proceso ${codigo_proceso}  al portapapeles`;
          that.snackbar = true;
        }
      );
    },
  },
  mounted() {},
};
</script>
